import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subscriptionTermsDaysFrequency'
})
export class SubscriptionTermsDaysFrequencyPipe implements PipeTransform {
  transform(subscriptionFrequency: string | undefined): string {
    const frequency = subscriptionFrequency?.toLowerCase() || '';

    switch (frequency) {
      case 'monthly':
        return '30 days';
      case 'bimonthly':
        return '60 days';
      case 'quarterly':
        return '90 days';
      case 'every 120 days':
        return '120 days';
      case 'semiannual':
        return '180 days';
      case 'annual':
        return '365 days';
      default:
        return '30 days'; // Default subscription days period
    }
  }
} 